(async () => {
  var e = await import(window.theme.modules.baseComponent);
  customElements.define(
    "product-qty",
    class extends e.default {
      render() {
        (this.currentVariant = +this.getAttribute("variant-id")),
          this.listenTo("variantChange", (e, t) => {
            (this.currentVariant = t.variant.id), this._rerender(t);
          }),
          this.listenTo(
            "qtyStatusUpdate",
            (e, t) => {
              this.currentVariant === +t.variantId && this._rerender(t);
            },
            !1
          );
      }
      _rerender(e) {
        const t = e.html.querySelector("product-qty");
        e = this.querySelector("select")?.value;
        if (e) {
          const r = t.querySelector(`option[value="${e}"]`);
          r && r.setAttribute("selected", !0);
        }
        this.replaceChildren(...t.cloneNode(!0).childNodes);
      }
    }
  );
})();

// $(document).ready(function () {
//   $(document).on("change", ".content-for-layout .quantity .main-quantity", function () {
//     let quantitySelect = $(this); // Select the dropdown
//     let quantityValue = quantitySelect.val(); // Get the selected value

//     if (quantitySelect.length) {
//       quantitySelect.find("option").removeClass("selected"); // Remove class from all options
//       quantitySelect.find(`option[value="${quantityValue}"]`).addClass("selected"); // Add class to selected option
//     }
//   });

//   // Initial update when page loads
//   $(".content-for-layout .quantity .main-quantity").each(function () {
//     let quantitySelect = $(this);
//     let quantityValue = quantitySelect.val();
//     quantitySelect.find(`option[value="${quantityValue}"]`).addClass("selected");
//   });
// });
